<template>
  <ModalDefault modal_id="showTicket"
                size="modal-lg"
                header="y"
                :modal_header="getTranslations('expression_546')"
                icon=""
                class_header="border-bottom"
                class_footer="border-top"
                :style_top_header="($mq === 'mobile' || $mq === 'tablet') ? 'position: fixed; top: 0; width: 100%; z-index: 999;' : ''"
                :style_footer="($mq === 'mobile' || $mq === 'tablet') ? 'position: fixed; bottom: 0; width: 100%; z-index: 999;' : ''"
                class_body="p-0"
                footer="y">
    <div slot="body" v-if="tickets.ticket">
      <div :style="($mq === 'mobile' || $mq === 'tablet') ? 'min-height: 70vh; max-height: 80vh;' : 'min-height: 410px; max-height: 410px;'" style="overflow-y: auto" class="card-body">
        <div id="chat_conversation" class="chat_conversation px-3  pb-1">
          <ChatBalloonDefault :history="history" v-for="history in tickets.histories_followup_ticket" :key="history.id"/>
        </div>
      </div>
    </div>
    <div slot="footer" class="col-12 d-flex justify-content-between cursor_default text-left py-2 ellipsis pl-4 pr-3">
      <div>
        <span v-b-tooltip.top
              :title="tickets.ticket.status ? tickets.ticket.status.status : '---'"
              :class="tickets.ticket.status ? `bg-${tickets.ticket.status.label}` : 'bg-secondary'"
              class="text-white py-2 px-3">
          <span class="">{{ tickets.ticket.status ? tickets.ticket.status.status : '---' }}</span>
        </span>
      </div>
      <div class="d-flex">
        <div v-if="tickets.ticket.status && tickets.ticket.status.done === 0 && [1,2].includes(me.data.role_key)">
          <span data-toggle="modal"
                data-dismiss="modal"
                data-target="#endTicketAdminModal"
                class="shadow-sm cursor_pointer btn-outline-danger py-2 px-3 mr-2">
            <i class="bx bx-block"></i>
            <span class="hidden-sm ml-2">{{ getTranslations('expression_541') }}</span>
          </span>
        </div>
        <div v-if="tickets.ticket.status && tickets.ticket.status.done === 0 && [1,2].includes(me.data.role_key)">
          <span data-toggle="modal"
                data-dismiss="modal"
                @click="clearTransfer"
                data-target="#transferTicketAdminModal"
                class="shadow-sm cursor_pointer btn-outline-primary rounded-0 py-2 px-3 mr-2">
            <i class="bx bx-transfer-alt"></i>
            <span class="hidden-sm ml-2">{{ getTranslations('expression_538') }}</span>
          </span>
        </div>
        <div>
          <span @click.prevent="openUrl(tickets.ticket.url_pdf)"
                class="shadow-sm cursor_pointer btn-secondary text-white py-2 px-3">
            <i class="bx bxs-file-pdf"></i>
            <span class="hidden-sm ml-2">{{ getTranslations('expression_799') }}</span>
          </span>
        </div>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import ChatBalloonDefault from "../../components/chat/ChatBalloonDefault";

export default {
  name: "ModalLeadShowTicket",
  components: {
    ModalDefault,
    ChatBalloonDefault
  },
  computed: {
    ...mapState(['leads', 'histories', 'tickets', 'me', 'configs']),
    ...mapGetters([])
  },
  methods: {
    openUrl(payload) {
      window.open(payload, "_blank");
    },
    clearTransfer() {
      this.tickets.ticket_transfer = {
        operator_id: null,
        department_id: null,
        channel_id: null
      }
    },
  }
}
</script>

<style src="../../assets/css/pages/chat.css" scoped/>
<style scoped>

</style>
